const REACT_STATICS: { [key: string]: boolean } = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  mixins: true,
  propTypes: true,
  type: true,
};

const KNOWN_STATICS: { [key: string]: boolean } = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  arguments: true,
  arity: true,
};

export function hoistNonReactStatics<O, T, S>(
  targetComponent: T,
  sourceComponent: S,
  customStatics?: { [key: string]: boolean }
): O {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    const keys: string[] = Object.getOwnPropertyNames(sourceComponent);

    // tslint:disable-next-line:prefer-for-of
    for (let i: number = 0; i < keys.length; ++i) {
      if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
        try {
          targetComponent[keys[i]] = sourceComponent[keys[i]];
        } catch (error) {
          console.warn(error);
        }
      }
    }
  }

  // tslint:disable-next-line:no-any
  return (targetComponent as any) as O;
}



// WEBPACK FOOTER //
// src/app/src/core/utils/hoistNonReactStatics.ts